import { ConnectedProps } from "react-redux";
import React, { useEffect } from "react";

import AddEditForm from "../AddEditForm";
import connector from "./Container";
import { useParams } from "react-router-dom";

const EditUser = ({ state, actions }: ConnectedProps<typeof connector>) => {
  const { id } = useParams();

  useEffect(() => {
    actions.getUserById(id);
  }, []);

  return (
    state.currentUser && (
      <AddEditForm isAdd={false} state={state} actions={actions} />
    )
  );
};

export default EditUser;
